// extracted by mini-css-extract-plugin
export var button = "TagList-module--button--bace9";
export var hideOnMobile = "TagList-module--hideOnMobile--382e6";